import engine from './engine.js';

const keys = {
  house: 'house',
  transport: 'transport',
  personal: 'personal',
  eatout: 'eatout',
  holiday: 'holiday',
  food: 'food',
  treat: 'treat',
}

const config = {
  ...engine,
  questionAnswerData: {
    cohabitingQuestion: {
      question: 'Are you co-habiting?',
      answers: {
        A: 'I live on my own',
        B: 'I live with my partner'
      }
    },
    single: {
      [keys.house]: {
        question: 'What will your home in retirement be like?',
        answers: {
          A: 'The essentials are enough for me',
          B: 'Well furnished - I like a few home comforts',
          C: 'Instagram worthy, with all the mod cons',
        }
      },
      [keys.transport]: {
        question: 'How are you going to get around?',
        answers: {
          A: "I'll hop on the bus",
          B: "I'll drive a mid-range car",
          C: "Comfort is key for me - I'd like a luxury car",
        }
      },
      [keys.personal]: {
        question: 'Will you treat yourself to new clothes and cosmetics?',
        answers: {
          A: "I'm pretty low maintenance",
          B: "I like to look good - I'll splash out occasionally",
          C: "I'm all about designer brands and high-end cosmetics",
        }
      },
      [keys.eatout]: {
        question: "You're eating out... where are you heading?",
        answers: {
          A: 'The chippy',
          B: 'The local pub',
          C: 'My nearest bistro',
        }
      },
      [keys.holiday]: {
        question: 'Are you planning to do much travelling?',
        answers: {
          A: 'Mainly UK-based trips here and there',
          B: 'Two to three trips a year, across the UK and Europe',
          C: 'Three or four holidays each year, somewhere more exotic',
        }
      },
      [keys.food]: {
        question: "You're eating in... what's for dinner?",
        answers: {
          A: "I'm content with food that's simple and fresh",
          B: "I tend to opt for the more premium brands",
          C: "Top of the range all the way",
        }
      },
      [keys.treat]: {
        question: "You're treating the family... what'll it be?",
        answers: {
          A: 'A trip to the cinema',
          B: 'A mini shopping spree',
          C: 'A full day out, plus souvenirs galore!',
        }
      },
    },
    // uncomment and populate below if we ever add different question/answer copy. Will also need to update config/index.js getQuestionAnswerData getter
    // cohabiting: {
    //   [keys.house]: {},
    //   [keys.transport]: {},
    //   [keys.personal]: {},
    //   [keys.eatout]: {},
    //   [keys.holiday]: {},
    //   [keys.food]: {},
    //   [keys.treat]: {},
    // }
  },
  currencySymbol: '£',
  headlineFigures: {
    single: {
      minimum: 14400,
      moderate: 31300,
      comfortable: 43100,
    },
    cohabiting: {
      minimum: 22400,
      moderate: 43100,
      comfortable: 59000,
    }
  },
  inputs: {
    age: {
      min: 18,
      max: 100,
      currentValue: 20, // initial value
    },
    retirementAge: {
      min: 50,
      max: 100,
      currentValue: 70, //initial value
    },
    currentBalance: {
      min: 0,
      max: 1000000,
      currentValue: 0,  //initial value
    },
  },
  engine: {
    interestRate: 0.04,
    statePension: 9627.80,
    annuityRate: 20,
  },
  targetIncomes: {
    single: {
      [keys.house]: {
        A: 120.29,
        B: 237.42,
        C: 343.19,
      },
      [keys.food]: {
        A: 33.21,
        B: 63.9,
        C: 82.52,
      },
      [keys.eatout]: {
        A: 36.74,
        B: 68.4,
        C: 89.89,
      },
      [keys.transport]: {
        A: 12.93,
        B: 86.73,
        C: 101.21,
      },
      [keys.holiday]: {
        A: 18.11,
        B: 46.16,
        C: 85.95,
      },
      [keys.treat]: {
        A: 10.29,
        B: 26.23,
        C: 48.83,
      },
      [keys.personal]: {
        A: 44.95,
        B: 80.03,
        C: 85.28,
      }
    },
    cohabiting: {
      [keys.house]: {
        A: 158.73,
        B: 283.36,
        C: 410.93,
      },
      [keys.food]: {
        A: 61.01,
        B: 108.01,
        C: 138.64 ,
      },
      [keys.eatout]: {
        A: 65.24,
        B: 117.46,
        C: 151.87,
      },
      [keys.transport]: {
        A: 20.64,
        B: 87.35,
        C: 104.06,
      },
      [keys.holiday]: {
        A: 28.68,
        B: 65.06,
        C: 118.9,
      },
      [keys.treat]: {
        A: 16.3,
        B: 36.97,
        C: 67.55,
      },
      [keys.personal]: {
        A: 77.1,
        B: 128.08,
        C: 138.7,
      }
    }
  },
  canChangeRetirementAge: true,
};

export default config;
